export default [
  { path: '/base/dic', name: 'BaseDic', component: () => import(/* webpackChunkName: "base-dic" */ './index.vue') }
]